<template>
  <div class="row">
    <!-- {{activeIndex}} // 
    {{form_data}}-->
    <!-- {{form_data}} -->
    <div class="col-md-12">
      <div class="form-group">
        <label>Recurring:</label>
        <div class="checkbox">
          <input
            @change="updateRecurring"
            v-model="isRecurring"
            :key="1"
            type="checkbox"
            name="checkbox"
          />
        </div>
      </div>
    </div>

    <div class="col-md-12" v-if="isRecurring">
      <div class="form-group">
        <label>Frequency</label>
        <select @change="updateRecurring" v-model="form_data.recurrence" class="form-control">
          <option>-- Select --</option>
          <option
            v-for="(item,index) in recurrenceOptions"
            :key="item+index"
            :label="item"
            :value="item"
          >{{item | capitalising}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12" v-if="isRecurring">
          <div class="form-group">
            <label>Set Time (HH:MM)</label>
            <br />
            <!-- {{start_hour}} -->
            <select @change="updateRecurring" style="width:50px;" v-model="start_hour">
              <option :value="''">-- Select --</option>
              <option :value="'00'">00</option>
              <option
                v-for="hour in 23"
                :key="hour"
                :value="(hour<10)?'0'+hour:hour"
              >{{(hour<10)?'0'+hour:hour}}</option>
            </select>
            <select @change="updateRecurring" style="width:50px;" v-model="start_minute">
              <option :value="''">-- Select --</option>
              <option :value="'00'">00</option>
              <option
                v-for="minute in 59"
                :key="minute"
                :value="(minute<10)?'0'+minute:minute"
              >{{(minute<10)?'0'+minute:minute}}</option>
            </select>
            <div classs="text-muted" style="font-size:11px;">Timezone in GMT+7 (Jakarta Time / WIB)</div>
          </div>
        </div>

        <div class="col-md-12" v-if="form_data.recurrence!='daily' && isRecurring">
          <div class="form-group" v-if="form_data.recurrence=='weekly'">
            <label>Every</label>
            <select
              @change="updateRecurring"
              v-model="form_data.recurrence_every"
              class="form-control"
            >
              <option>-- Select Day --</option>
              <option
                v-for="(item,index) in weeklyOptions"
                :key="item+index"
                :label="item"
                :value="item"
              >{{item | capitalising}}</option>
            </select>
          </div>
          <div class="form-group" v-if="form_data.recurrence!='weekly'">
            <label>Every</label>
            <select
              @change="updateRecurring"
              v-model="form_data.recurrence_every"
              class="form-control"
            >
              <option>-- Select --</option>
              <option
                v-for="(item,index) in monthlyOptions"
                :key="item+index"
                :label="item"
                :value="item"
              >{{item | capitalising}}</option>
            </select>
          </div>
        </div>
        <div
          class="col-md-12"
          v-if="form_data.recurrence!='daily' && form_data.recurrence!='weekly' && isRecurring"
        >
          <div class="form-group" v-if="form_data.recurrence=='annually'">
            <label>Select Month</label>

            <select
              @change="updateRecurring"
              v-model="form_data.recurrence_annually_month"
              class="form-control"
            >
              <option>-- Select --</option>
              <option
                v-for="(item,index) in annuallyMonthOptions"
                :key="item+index"
                :label="item"
                :value="item"
              >{{item | capitalising}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12" v-if="isRecurring">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>End Date</label>
            <select v-model="form_data.recurrence_end" class="form-control">
              <option>-- Select --</option>
              <option
                v-for="(item,index) in recurrenceEndOptions"
                :key="item+index"
                :label="item"
                :value="item"
              >{{item | capitalising}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-12" v-if="form_data.recurrence_end!='never'">
          <div class="form-group">
            <label>Select Date</label>

            <input
              @change="updateRecurring"
              class="form-control datetimepicker"
              v-model="form_data.recurrence_end_date"
              type="date"
            />
            <!-- <datetime
              :min-datetime="currentDateTimeUTC()"
              :zone="'local'"
              input-class="form-control"
              value-zone="UTC"
              type="date"
              v-model="form_data.recurrence_end_date"
            ></datetime>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { currentDateTimeUTC, convertTzDatetimeToDateISO } from "@/utils/helper";
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
export default {
  components: {
    Datetime
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      start_hour: "00",
      start_minute: "01",
      getContentOptions: {},
      loading: false,
      isRecurring: false,
      recurrenceOptions: ["daily", "weekly", "monthly", "annually"],
      weeklyOptions: [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday"
      ],
      monthlyOptions: [
        "first",
        "last",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31"
      ],
      annuallyMonthOptions: [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december"
      ],
      recurrenceEndOptions: ["never", "custom"],
      form_data: {
        recurrence: "daily",
        recurrence_time: this.start_hour + ":" + this.start_minute,
        recurrence_every: "",
        recurrence_annually_month: "",
        recurrence_end: "never",
        recurrence_end_date: ""
      }
    };
  },
  computed: {
    detailBroadcast() {
      return this.$store.state.omniwa.detailBroadcast;
    },
    formParamScrapeSt() {
      return this.$store.state.instagramSchedule.formParamScrapeSt;
    },
    isShowBroadcast() {
      return 0;
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  created() {},
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
  },
  watch: {
    formParamScrapeSt: {
      handler: async function(val, oldVal) {
        if (val != oldVal) {
          // console.log("oldValForm3", oldVal);
          // console.log("newValForm3", val);

          if (val.is_recurring == 1) {
            let splitHour = val.recurring_form.recurrence_time.split(":");
            this.start_hour = splitHour[0];
            this.start_minute = splitHour[1];
            this.isRecurring = true;
            this.form_data=val.recurring_form;
            // this.formData.recurrence = val.recurrence;
            // this.formData.recurrence_time = val.recurrence_time;
            // this.formData.recurrence_every = val.recurrence_every;
            // this.formData.recurrence_annually_month =
            //   val.recurrence_annually_month;
            // this.formData.recurrence_end = val.recurrence_end;
            // this.formData.recurrence_end_date = val.recurrence_end_date;
          }
        }
      },
      deep: true
    },
    activeIndex: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == 2) {
          var that = this;
          setTimeout(function() {
            
            that.updateRecurring();
          }, 200);
        }
      },
      deep: true
    }
  },
  methods: {
    convertTzDatetimeToDateISO(utcdatetime) {
      return convertTzDatetimeToDateISO(utcdatetime);
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    updateRecurring() {
      // let dataParam = {
      //   mp_product_master_id: "",
      //   keywords_id: [],
      //   min_price: 0,
      //   max_price: 0,
      //   sort_by: "price",
      //   order_by: "asc",
      //   mp_id: [],
      //   sending_options: 1,
      //   is_publish: 1,
      //   is_recurring: 0,
      //   recurring_form: {
      //     recurrence: "",
      //     recurrence_time: "00:01",
      //     recurrence_every: "",
      //     recurrence_annually_month: "",
      //     recurrence_end: "never",
      //     recurrence_end_date: ""
      //   }
      // };
      let dataParam = this.formParamScrapeSt;
      // let form1 = this.formParamScrapeSt;
      // dataParam.mp_product_master_id = form1.mp_product_master_id;
      // dataParam.keywords_id = form1.keywords_id;
      // dataParam.min_price = parseInt(form1.min_price);
      // dataParam.max_price = parseInt(form1.max_price);
      // dataParam.sort_by = form1.sort_by;
      // dataParam.order_by = form1.order_by;
      // dataParam.mp_id = form1.mp_id;
      // dataParam.sending_options = form1.sending_options;
      // dataParam.sending_schedule = this.sendingSchedule;
      // dataParam.is_recurring = this.isRecurring;

      // let dataParam = this.formParamScrapeSt;
      // let dataParam = this.formParamScrapeSt;
      if (this.isRecurring == true) {
        dataParam.is_recurring = 1;
      } else {
        dataParam.is_recurring = 0;
      }
      dataParam.recurring_form = this.form_data;
      dataParam.recurring_form.recurrence_time =
        this.start_hour + ":" + this.start_minute;

      console.log("dataParam", dataParam);
      // this.$store.dispatch("omniwa/actBroadcastParamSt", dataParam);
      this.$store.dispatch("instagramSchedule/actFormParamScrapeSt", dataParam);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/instagram/instagramScheduleOfficial/components/scheduler.vue